/**
 * Tab-scoped persistence for admin auth tokens.
 *
 * Access tokens stay in memory for API calls; we mirror them (and the
 * refresh token) into sessionStorage so a full page reload can restore the
 * session without hitting /login again.
 *
 * Hard rules (unchanged from admin-token-storage):
 *   - NEVER write to localStorage (XSS + long-lived risk).
 *   - sessionStorage is cleared when the tab closes.
 */

const ACCESS_KEY = "zone_admin.access_token";
const REFRESH_KEY = "zone_admin.refresh_token";

export function getPersistedAccessToken(): string | null {
  try {
    return sessionStorage.getItem(ACCESS_KEY);
  } catch {
    return null;
  }
}

export function setPersistedAccessToken(token: string | null): void {
  try {
    if (token) sessionStorage.setItem(ACCESS_KEY, token);
    else sessionStorage.removeItem(ACCESS_KEY);
  } catch {
    // Private browsing / disabled storage — in-memory auth still works
    // until refresh.
  }
}

export function getPersistedRefreshToken(): string | null {
  try {
    return sessionStorage.getItem(REFRESH_KEY);
  } catch {
    return null;
  }
}

export function setPersistedRefreshToken(token: string | null): void {
  try {
    if (token) sessionStorage.setItem(REFRESH_KEY, token);
    else sessionStorage.removeItem(REFRESH_KEY);
  } catch {
    // ignore
  }
}

export function clearPersistedAdminSession(): void {
  setPersistedAccessToken(null);
  setPersistedRefreshToken(null);
}
